import React, {Component} from 'react';
import Radium from 'radium';
import LinkDefault from 'react-router/lib/Link'

import { colors } from '../theme'
// import ProfileImage from '../../img/profile.svg';
import Button from './Button';

let styles;
const Link = Radium(LinkDefault)

class Circle extends Component {
  render() {
    const {
      name,
      image,
      link,
      isAdmin,
      secondaryOrganizerType,
      actionParticipant,
      caption,
      controls,
      style = {},
      iconStyle = {},
      nameStyle = {},
      captionStyle = {},
    } = this.props;

    return (
      <div style={styles.circleContainer}>
        {isAdmin &&
          (
            <Button
              onClick={actionParticipant}
              style={styles.close}
              text={<i style={styles.closeIcon} className="fa fa-times fa-2x" />}
            />
          )
        }
        <Link to={link} style={{...styles.circle, ...style}}>
          <div style={{...styles.icon, ...iconStyle, backgroundImage: 'url('+image || "../../img/profile.png" +')'}} />
          <div style={{...styles.name, ...nameStyle}}>{name}</div>
          {secondaryOrganizerType &&
            <div style={styles.organizerType}>{secondaryOrganizerType}</div>
          }
          {caption && <div style={{...styles.name, ...captionStyle}}>{caption}</div>}
        </Link>
        {controls}
      </div>
    );
  }
}

styles = {
  circleContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
  },
  circle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textDecoration: 'none',
    width: '100%'
  },
  icon: {
    width: 40,
    height: 40,
    flexShrink: 0,
    borderRadius: '50%',
    marginBottom: 7,
    backgroundPosition: '50% 50%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },

  name: {
    color: colors.black,
    fontSize: 17,
    fontWeight: 500,
    textDecoration: 'none',
    textTransition: 'none',
    width: '100%',
    textAlign: 'center',
    wordWrap: 'break-word'
  },
  organizerType: {
    color: colors.black,
    fontSize: 17,
    fontWeight: 500,
    fontStyle: 'italic',
    textDecoration: 'none',
    textTransition: 'none',
    width: '100%',
    textAlign: 'center',
    wordWrap: 'break-word',
    marginTop: 2
  },
  close: {
    backgroundColor: colors.red,
    color: colors.white,
    width: 20,
    height: 20,
    borderRadius: 10,
    borderStyle: 'none',
    fontSize: 12,
    cursor: 'pointer',
    position: 'relative',
    top: 15,
    right:-110,
  },
  closeIcon: {
    fontSize: '14px',
    position: 'absolute',
    top: 3,
    left: 5
  }
}


export default Radium(Circle);



// WEBPACK FOOTER //
// ./src/components/Circle.js